import { call, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { selectRoomId } from 'features/room/roomSlice';
import { signalingEncryptionKeyShared } from 'features/e2ee/actions';
import { logger } from 'utils/logger';

export function* onEncryptionKeySharedSaga(
  action: ReturnType<typeof signalingEncryptionKeyShared>
) {
  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    const { initiator, streamKey, applicationKey, name } = action.payload;
    const roomId: string = yield select(selectRoomId);

    try {
      yield call(E2EEManager.decryptRemoteData, initiator.id, roomId, {
        applicationKey,
        streamKey,
        name,
      });
    } catch (error) {
      const message = `[E2EE] Failed to decrypt remote data for userId=${initiator.id}`;
      logger.remote({ system: true, capture: 'e2ee' }).error(message, {
        error: error instanceof Error ? error.message : JSON.stringify(error),
      });
      Sentry.captureException(error);
    }
  }
}
